export enum ExportStatus {
    IN_PROGRESS = "In Progress",
    PARTIAL_SUCCESS = "Partial Success",
    SUCCESS = "Success",
    FAILURE = "Failure",
    PENDING = "Pending",
    // TaskDefinitionRecord terminal states. It reports "Failed" (not SysProcessLog's "Failure") and
    // adds "Cancelled"; FAILURE stays for the import log, which is a different grid/entity.
    FAILED = "Failed",
    CANCELLED = "Cancelled",
}

export interface ProcessLogData {
    status: ExportStatus | null;
    totalRecords: number;
    processedRecords: number;
    exportFileId: number | null;
    exportFileName: string | null;
}
